import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';
import { Link, useHistory, useParams } from 'react-router-dom';

import communityImage from '../../../assets/images/community-image-1.jpg';
import React, { useEffect, useState } from 'react';
import { currentDate, frontendRoutes } from '../../../Constants/constants';
import { useDispatch, useSelector } from 'react-redux';
import {
  addPropertyId,
  addStaticToken,
  getBuilderId,
  get_property_details,
  tourDate,
} from '../../../redux/action/action';
import { Button } from '../../Button/Button';
import { Form } from 'react-bootstrap';
import { checkPropertyBuilder, getPropertyInfo } from '../../../Constants/api';
import { ReactComponent as BackIcon } from '../../../assets/images/icn-arrow-prev.svg';
import { Disclosure } from '../../Disclosure/Disclosure';
import { FormikProvider, FormikValues, useFormik } from 'formik';
import { enterPropertyValidation } from '../../../Constants/validations';
import { BuilderSettings } from '../../../redux/types/builders';
import { useTranslation } from 'react-i18next';
import { fpGetEvent } from '../../../utils/fingerprint';
import { getCustomerIdFromToken, getPropertyAccessNextPath } from '../../../utils';

export const EnterProperty = () => {
  const { t } = useTranslation();
  const params = useParams<{ builder_name: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  const builderId = useSelector((state: any) => state.builder.builder_id);
  const propertyBuilder = useSelector((state: any) => state?.property?.property?.builder);
  const userToken = localStorage.getItem('user_token');
  const [communityId, setCommunityId] = useState('');
  const [propertyError, setPropertyError] = useState<string | null>(null);
  const [nextPage, setNextPage] = useState(false);
  const builderSettings: BuilderSettings = useSelector((state: any) => state.builder.settings);
  const userInfo = useSelector((state: any) => state.user.userInfo);

  const formik = useFormik<FormikValues>({
    validateOnChange: false,
    initialValues: {
      propertyId: '',
      privacyPolicy: false,
      customDisclosureActive: false,
      customDisclosure: false,
    },
    validationSchema: enterPropertyValidation,
    onSubmit: values => {
      return checkProperty(values.propertyId);
    },
  });

  useEffect(() => {
    if (builderId) {
      return;
    }

    localStorage.setItem('builder_name', params.builder_name);

    dispatch(addStaticToken());
    dispatch(getBuilderId());
  }, [builderId, dispatch, params.builder_name]);

  useEffect(() => {
    if (!nextPage) {
      return;
    }

    const isDemoMode = propertyBuilder?.toLowerCase() === 'demo mode';

    !builderSettings.geolocation_active || isDemoMode
      ? history.push(frontendRoutes.LockCodeScreen(params.builder_name).path)
      : history.push(frontendRoutes.shareLocation(params.builder_name).path);

    setNextPage(false);
  }, [history, nextPage, params.builder_name, propertyBuilder, builderSettings.geolocation_active]);

  const checkProperty = async (propertyId: string) => {
    setCommunityId('');

    const propertyBuilderId = await checkPropertyBuilder(Number(propertyId));

    if (propertyBuilderId !== builderId) {
      setPropertyError(t('property_not_found', { propertyId }));
      return;
    }

    const property = await getPropertyInfo(propertyId, userInfo?.customer_id);

    if (property?.community_id) {
      setCommunityId(property?.community_id);
    }

    const isPropertyVisitable =
      (property?.propStatus === 'PROPERTY_AVAILABLE' && property?.lockStatus === 'LOCK_ACTIVE') ||
      (property?.propStatus === 'PROPERTY_AVAILABLE' && property?.hub_serial_number) ||
      (property?.propStatus === 'PROPERTY_AVAILABLE' && property?.smart_lock_serial_number);

    if (!isPropertyVisitable) {
      if (
        property?.lockStatus !== 'LOCK_ACTIVE' &&
        !property?.hub_serial_number &&
        !property?.smart_lock_serial_number
      ) {
        setPropertyError(t('no_active_lock'));
        return;
      }

      setPropertyError(t('access_issue', { propStatusDescription: property?.propStatusDescription }));
      return;
    }

    dispatch(get_property_details(property));
    dispatch(addPropertyId(propertyId));
    setPropertyError(null);

    fpGetEvent({
      linkedId: getCustomerIdFromToken(userToken),
    });

    const nextPath = getPropertyAccessNextPath(
      params.builder_name,
      builderSettings.geolocation_active,
      property?.builder,
    );

    if (!property.didCompleteSurveyForBuilder) {
      history.push(frontendRoutes.surveyQuestions(params.builder_name).path, { nextPath });
      return;
    }

    const nowDate = 'Today ' + currentDate;
    const data = {
      showDate: nowDate,
      radioTime: 'now',
      customTime: new Date().toLocaleTimeString('en-GU', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      }),
    };

    dispatch(tourDate(data));
    setNextPage(true);
  };

  if (propertyError) {
    return (
      <section className="main-section location-screen d-flex justify-content-center">
        <div className="box">
          <div className="main-title"></div>
          <span
            onClick={() => {
              setPropertyError(null);
              setNextPage(false);
              formik.setFieldValue('propertyId', '');
            }}
            className="link-back icn icn-back-arrow"
          ></span>
          <div className="box-data d-flex flex-column text-center">
            <i className={`icn ${true ? 'icn-error-pin' : 'icn-pin'}`}></i>
            <h1 className="h2">{t('uh_oh')}</h1>
            <div className="error-message-container">
              <p className="m-0">
                {propertyError + ' '}
                {communityId && (
                  <Link to={frontendRoutes.community(params.builder_name, communityId).path}>
                    {t('explore_other_properties')}
                  </Link>
                )}
              </p>
            </div>
            <Button
              onClick={() => {
                setPropertyError(null);
                setNextPage(false);
                formik.setFieldValue('propertyId', '');
              }}
              className="button back-button mb-5"
              style={{ marginTop: '50px' }}
            >
              <BackIcon />
              {t('try_again')}
            </Button>
            <Button
              onClick={() => {
                history.push(frontendRoutes.chooseCommunity(params.builder_name).path);
              }}
              className="button back-button mb-5"
            >
              {t('find_other_properties')}
            </Button>
            <a
              href="tel:+844-531-1283"
              className="need-help-link d-flex justify-content-center gap-1 mt-3"
              target="_blank"
              rel="noreferrer"
            >
              {t('need_help')} <i className="icn icn-phone"></i>
            </a>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="main-section community-screen d-flex  justify-content-center">
      <div className="box">
        <Header />
        <span
          onClick={() => {
            history.goBack();
          }}
          className="link-back icn icn-back-arrow"
        ></span>
        <div className="box-data d-flex flex-column position-relative">
          <div className="mt-auto mb-auto">
            <h1 className="title" style={{ margin: '0 0 95px 0' }}>
              {t('enter_property_id')}
            </h1>
            <figure className="text-center community-image">
              <img src={communityImage} alt={t('community')} />
            </figure>
          </div>
          <Form
            onSubmit={formik.handleSubmit}
            style={{ marginTop: '20px' }}
          >
            <FormikProvider value={formik}>
              <Form.Group controlId="propertyId">
                <Form.Control
                  type="text"
                  placeholder={t('property_id_placeholder')}
                  name="propertyId"
                  onChange={formik.handleChange}
                  value={formik.values.propertyId}
                />
                {formik.errors.propertyId ? (
                  <span className="invalid-feedback d-block">{formik.errors.propertyId}</span>
                ) : (
                  ''
                )}
              </Form.Group>
              <div className="box-footer mt-auto">
                <Disclosure builderSettings={builderSettings} formik={formik} />
                <Button
                  type="submit"
                  className={`button w-100`}
                  style={{ lineHeight: 1.4, padding: '10px' }}
                >
                  {t('continue')}
                </Button>
              </div>
            </FormikProvider>
          </Form>
        </div>
        <Footer />
      </div>
    </section>
  );
};
